import SelectBank from '@/components/select-bank/index.vue';

export default {
  components: {
    SelectBank
  },
  data () {
    return {
      changeBankFlag: false,
      bidId: ''
    };
  },
  methods: {
    updateBank(bidId) {
      this.changeBankFlag = true;
      this.bidId = bidId;
    }
  }
};
